<template>
  <div class="recipe content-page">
    <categories />
    <results-bar
      :total="filteredRecipes.length"
      :label="resultsLabel"
      icon="utensils"
      tile-selector=".recipe-card"
    />
    <div class="content container recipes">
      <subcategories />
      <div class="recipes-container">
        <recipetile
          class="recipe-card"
          v-for="recipe in filteredRecipes.slice(0, this.nrOfRecipesToShow)"
          :recipe="recipe"
          :key="recipe.id"
        />
      </div>
    </div>
    <loadmore />
  </div>
</template>

<script>
import categories from "./category/CategoryFilter";
import subcategories from "./category/SubCategoryFilter";
import recipetile from "./recipe/RecipeTile";
import loadmore from "@/components/common/LoadMore";
import resultsBar from "@/components/common/ResultsBar";

export default {
  created() {
    const isSameAsLast = this.$store.getters.currentCategory.Name == this.$route.params.category.split("-").join(" ")
    if(!isSameAsLast){
      this.$store.dispatch(
        "setCurrentCategory",
        this.$route.params.category.split("-").join(" ")
      );
    }
    this.$store.commit('setTitle', this.$store.getters.currentCategory.Name)
  },
  computed: {
    nrOfRecipesToShow() {
      return this.$store.getters.nrOfRecipesToShow;
    },
    filteredRecipes() {
      return this.$store.getters.filteredRecipes;
    },
    resultsLabel() {
      return this.filteredRecipes.length === 1 ? 'opskrift' : 'opskrifter';
    }
  },
  components: {
    categories,
    subcategories,
    recipetile,
    loadmore,
    "results-bar": resultsBar
  }
};
</script>

<style lang="scss">
</style>